import React, { useEffect, useState } from "react";
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { MDBDataTable } from 'mdbreact';
import { gql } from 'apollo-boost';
import { useQuery, useMutation } from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';

import { activateAuthLayout } from '../../../../store/actions';

const GET_USERS = gql`
    query {
        Users {
            id
            email
            FirstName
            LastName
            TeamId
            Team {
                TeamId
                Name
            }
        }
    }
`;

const DELETE_USER = gql`
    mutation deleteUser($userID: userID) {
        deleteUser(input: $userID) {
            status
            message
        }
    }
`;

const ManageUsers = ({ activateAuthLayout }) => {
    const { data, loading, refetch } = useQuery(GET_USERS);
    const [deleteUser] = useMutation(DELETE_USER);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [mutateResult, setMutateResult] = useState(null);

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: ['First Name', <i key="first_name" className="fa fa-sort ml-2"></i>],
                field: 'first_name',
                sort: 'asc'
            },
            {
                label: ['Last Name', <i key="last_name" className="fa fa-sort ml-2"></i>],
                field: 'last_name',
                sort: 'asc'
            },
            {
                label: ['Email', <i key="email" className="fa fa-sort ml-2"></i>],
                field: 'email',
                sort: 'asc'
            },
            {
                label: ['Team', <i key="team" className="fa fa-sort ml-2"></i>],
                field: 'team',
                sort: 'asc'
            },
            {
                label: 'Actions',
                field: 'actions',
                sort: 'disabled',
            },
        ],
    });

    useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

    useEffect(() => {
        if (!loading) {
            const rows = (data?.Users ?? []).map(u => ({
                first_name: u.FirstName,
                last_name: u.LastName,
                email: u.email,
                team: u.Team?.Name ?? '—',
                actions: (
                    <div className="d-flex justify-content-end gap-2">
                        <Link to={`/admin/edit-user/${u.id}`} className="btn btn-sm btn-info mr-2">
                            Edit
                        </Link>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => setDeleteTarget(u)}
                        >
                            Delete
                        </button>
                    </div>
                ),
            }));
            setTableData(prev => ({ ...prev, rows }));
        }
    }, [data, loading]);

    return (
        <React.Fragment>
            {deleteTarget && (
                <SweetAlert
                    warning
                    title="Confirm"
                    onConfirm={() => {
                        const target = deleteTarget;
                        setDeleteTarget(null);
                        deleteUser({ variables: { userID: { user_id: target.id } } })
                            .then(({ data: { deleteUser: res } }) => {
                                if (res.status === 200) {
                                    refetch();
                                } else {
                                    setMutateResult({ title: 'Error', message: res.message || 'Failed to delete user.', type: 'danger', showConfirm: true });
                                }
                            })
                            .catch(() => setMutateResult({ title: 'Error', message: 'Failed to delete user.', type: 'danger', showConfirm: true }));
                    }}
                    onCancel={() => setDeleteTarget(null)}
                    showCancel
                    confirmBtnText="Delete"
                    cancelBtnText="Cancel"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                >
                    Delete "{deleteTarget.FirstName} {deleteTarget.LastName}"?
                </SweetAlert>
            )}
            <div className="content">
                <div className="container-fluid">
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col sm="6">
                                <h4 className="page-title">People</h4>
                            </Col>
                            <Col sm="6" className="text-right">
                                <Link to="/admin/create-user" className="btn btn-success">Create New Person</Link>
                            </Col>
                        </Row>
                    </div>
                    <div className="rounded bg-white p-4">
                        {!loading && <MDBDataTable
                            sortable
                            striped
                            borderless
                            theadColor="table-dark"
                            hover
                            responsive
                            noBottomColumns
                            noRecordsFoundLabel="No People Found"
                            data={tableData}
                        />}
                    </div>
                </div>
            </div>
            {mutateResult && (
                <SweetAlert
                    type={mutateResult.type}
                    title={mutateResult.title}
                    onConfirm={() => setMutateResult(null)}
                    showConfirm={mutateResult.showConfirm}
                    timeout={mutateResult.showConfirm ? 0 : 2500}
                >
                    {mutateResult.message}
                </SweetAlert>
            )}
        </React.Fragment>
    );
};

export default connect(null, { activateAuthLayout })(ManageUsers);
